@if (errorMessage; as message) {
    <div class="field-error" role="alert" [attr.data-testid]="testId || 'field-error'">
        {{ message }}
    </div>
}
